module.exports = __webpack_public_path__ + "img/job-special-risk.f9996f35.svg";